import { IUserPermissions } from '../sharedTypes';

interface IPermissions {
  id: number;
  name: string;
  paid_role: boolean;
  user_type: string;
  feature_groups: {
    name: string;
    permissions: string[];
  }[];
}

export const getPermissions = () => {
  const encodedUserPermissions = document
    .querySelector('meta[name="user-permissions"]')
    ?.getAttribute('value');
  const decodedPermissions = JSON.parse(JSON.parse(atob(encodedUserPermissions!)));
  return decodedPermissions;
};

export const formatUserPermissions = (): IUserPermissions => {
  const allRoles: Record<string, Record<string, boolean>> = {};
  getPermissions().roles.forEach((role: IPermissions) =>
    role.feature_groups.forEach((group) => {
      !allRoles[group.name] ? (allRoles[group.name] = {}) : null;
      group.permissions.forEach((permission) => (allRoles[group.name][permission] = true));
    })
  );
  const hasRecruitmentTeamEnabled = getPermissions().roles.some(
    (user) => user.recruitment_team_enabled
  );
  const paidUser = getPermissions().roles.some((user) => user.paid_role);
  allRoles['paid_user'] = paidUser;
  allRoles['recruitment_team_enabled'] = hasRecruitmentTeamEnabled;
  allRoles['user_type'] = getPermissions().roles[0]?.user_type;
  return allRoles;
};

export const formatUserPermissionsAsArray = () => {
  const rolesArray: string[] = [];
  getPermissions().roles.forEach((role: IPermissions) =>
    role.feature_groups.forEach((group) => {
      if (rolesArray.includes(group.name)) return;
      group.permissions.forEach((permission) => rolesArray.push(permission));
    })
  );
  return rolesArray;
};
